var searchElementByClassName = function(el, className) {
	if(el !== null && el instanceof HTMLElement && el !== undefined && el !== document.body) {
		if(el.classList.contains(className)) return el;
		else return searchElementByClassName(el.parentElement, className);
	} else return false;
}

var searchElementByTagName = function(el, tagName) {
	if(el !== null && el instanceof HTMLElement && el !== undefined && el !== document.body) {
		if(el.tagName === tagName) return el;
		else return searchElementByTagName(el.parentElement, tagName);
	} else return false;
}

var searchElementByID = function(el, ID) {
	var parent = document.getElementById(ID);
	var tag = el.tagName;
	var elems;
	var isParent = false;

	if(parent) elems = parent.getElementsByTagName(tag);

	elems = Spread(elems);

	elems.forEach(element => {
		if(element === el) isParent = true;
	});

	return isParent;
}